import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-photo-viewer',
  templateUrl: './photo-viewer.component.html',
  styleUrls: ['./photo-viewer.component.scss'],
})
export class PhotoViewerComponent implements OnInit {

  @ViewChild('img', { read: ElementRef }) image : ElementRef;

  @Input() Data;
  public loaded : Boolean;
  public ShowInfo : Boolean = false;
  public IsDark : Boolean = true;
  public IsEditing : Boolean = false;
  public Brightness : Number = 100;
  public Contrast : Number = 100;
  public Invert : Number = 0;
  public Horizontal : Number = 1;
  public Vertical : Number = 1;

  constructor(private modalCtrl: ModalController) {  }

  ngOnInit() {
    history.pushState({
      viewer : true,
      desc : 'fake state'
    }, "modal");
  }

  ngOnDestroy() {
    if (window.history.state.viewer) {
      history.back();
    }
  }

  @HostListener('window:popstate', ['$event'])
  dismiss() {
    this.modalCtrl.dismiss();
  }

  Download(){
    document.location.href = this.Data.Link;
  }

  public ChangeBrightness(value){
    this.Brightness = value;
    this.Editing();
  }
  public ChangeContrast(value){
    this.Contrast = value;
    this.Editing();
  }
  public ChangeInvert(){
    this.Invert = this.Invert == 0 ? 1 : 0;
    this.Editing();
  }
  public ChangeHorizontal(){
    this.Horizontal = this.Horizontal == 1 ? -1 : 1;
    this.Editing();
  }
  public ChangeVertical(){
    this.Vertical = this.Vertical == 1 ? -1 : 1;
    this.Editing();
  }
  public Editing(){
    if(this.image){
      this.image.nativeElement.style = `filter:brightness(${this.Brightness}%) contrast(${this.Contrast}%) invert(${this.Invert});
      transform:scaleX(${this.Horizontal}) scaleY(${this.Vertical})`;
    }
  }
  public RefreshEditing(){
    this.Brightness = this.Contrast = 100; this.Invert = 0; this.Horizontal = 1; this.Vertical = 1;
    this.Editing();
  }

}
